export const GET_ROF_BURNS_BATCH_DATA_SUCCESS = 'GET_ROF_BURNS_BATCH_DATA_SUCCESS';
export const GET_ROF_BURNS_BATCH_DATA_FAIL = 'GET_ROF_BURNS_BATCH_DATA_FAIL';

export const GET_ROF_BURNS_BATCH_MEDIA_SUCCESS = 'GET_ROF_BURNS_BATCH_MEDIA_SUCCESS';
export const GET_ROF_BURNS_BATCH_MEDIA_FAIL = 'GET_ROF_BURNS_BATCH_MEDIA_FAIL';

export const GET_ROF_BURNS_ADDITIONAL_BATCH_DATA_SUCCESS = 'GET_ROF_BURNS_ADDITIONAL_BATCH_DATA_SUCCESS';
export const GET_ROF_BURNS_ADDITIONAL_BATCH_DATA_FAIL = 'GET_ROF_BURNS_ADDITIONAL_BATCH_DATA_FAIL';

export const GET_ROF_BURNS_BATCH_VOLUMES_SUCCESS = 'GET_ROF_BURNS_BATCH_VOLUMES_SUCCESS';
export const GET_ROF_BURNS_BATCH_VOLUMES_FAIL = 'GET_ROF_BURNS_BATCH_VOLUMES_FAIL';

export const GET_ROF_BURNS_BATCH_BULK_DENSITY_SUCCESS = 'GET_ROF_BURNS_BATCH_BULK_DENSITY_SUCCESS';
export const GET_ROF_BURNS_BATCH_BULK_DENSITY_FAIL = 'GET_ROF_BURNS_BATCH_BULK_DENSITY_FAIL';

export const GET_ROF_BURNS_BIOCHAR_MASS_SUCCESS = 'GET_ROF_BURNS_BIOCHAR_MASS_SUCCESS';
export const GET_ROF_BURNS_BIOCHAR_MASS_FAIL = 'GET_ROF_BURNS_BIOCHAR_MASS_FAIL';

export const POST_ROF_BURNS_LAB_REPORT_FILE_SUCCESS = 'POST_ROF_BURNS_LAB_REPORT_FILE_SUCCESS';
export const POST_ROF_BURNS_LAB_REPORT_FILE_FAIL = 'POST_ROF_BURNS_LAB_REPORT_FILE_FAIL';

export const GET_ROF_BURNS_LAB_REPORT_FILES_SUCCESS = 'GET_ROF_BURNS_LAB_REPORT_FILES_SUCCESS';
export const GET_ROF_BURNS_LAB_REPORT_FILES_FAIL = 'GET_ROF_BURNS_LAB_REPORT_FILES_FAIL';

export const POST_BASE_LOG_KILN_SUCCESS = 'POST_BASE_LOG_KILN_SUCCESS';
export const POST_BASE_LOG_KILN_FAIL = 'POST_BASE_LOG_KILN_FAIL';

export const GET_BASE_LOG_KILNS_SUCCESS = 'GET_BASE_LOG_KILNS_SUCCESS';
export const GET_BASE_LOG_KILNS_FAIL = 'GET_BASE_LOG_KILNS_FAIL';

export const GET_PROJECT_BATCHES_SUCCESS = 'GET_PROJECT_BATCHES_SUCCESS';
export const GET_PROJECT_BATCHES_FAIL = 'GET_PROJECT_BATCHES_FAIL';

export const GET_DOWNLOAD_BATCH_REPORT_SUCCESS = 'GET_DOWNLOAD_BATCH_REPORT_SUCCESS';
export const GET_DOWNLOAD_BATCH_REPORT_FAIL = 'GET_DOWNLOAD_BATCH_REPORT_FAIL';

export const POST_BASE_BUCKET_SUCCESS = 'POST_BASE_BUCKET_SUCCESS';
export const POST_BASE_BUCKET_FAIL = 'POST_BASE_BUCKET_FAIL';

export const GET_BASE_BUCKETS_SUCCESS = 'GET_BASE_BUCKETS_SUCCESS';
export const GET_BASE_BUCKETS_FAIL = 'GET_BASE_BUCKETS_FAIL';

export const POST_BASE_EQUIPMENT_SUCCESS = 'POST_BASE_EQUIPMENT_SUCCESS';
export const POST_BASE_EQUIPMENT_FAIL = 'POST_BASE_EQUIPMENT_FAIL';

export const GET_BASE_EQUIPMENT_SUCCESS = 'GET_BASE_EQUIPMENT_SUCCESS';
export const GET_BASE_EQUIPMENT_FAIL = 'GET_BASE_EQUIPMENT_FAIL';

export const API_GET_APPLICATION_TYPE_SUCCESS = 'API_GET_APPLICATION_TYPE_SUCCESS';
export const API_GET_APPLICATION_TYPE_FAIL = 'API_GET_APPLICATION_TYPE_FAIL';

export const GET_ROF_BURNS_USERS_SUCCESS = 'GET_ROF_BURNS_USERS_SUCCESS';
export const GET_ROF_BURNS_USERS_FAIL = 'GET_ROF_BURNS_USERS_FAIL';

export const ADD_USER_TO_PROJECT_SUCCESS = 'ADD_USER_TO_PROJECT_SUCCESS';
export const ADD_USER_TO_PROJECT_FAIL = 'ADD_USER_TO_PROJECT_FAIL';

export const GET_FARM_PROJECTS_SUCCESS = 'GET_FARM_PROJECTS_SUCCESS';
export const GET_FARM_PROJECTS_FAIL = 'GET_FARM_PROJECTS_FAIL';

export const GET_PROJECT_INFO_SUCCESS = 'GET_PROJECT_INFO_SUCCESS';
export const GET_PROJECT_INFO_FAIL = 'GET_PROJECT_INFO_FAIL';

export const POST_PROJECT_INFO_SUCCESS = 'POST_PROJECT_INFO_SUCCESS';
export const POST_PROJECT_INFO_FAIL = 'POST_PROJECT_INFO_FAIL';

export const GET_BIOCHAR_LAB_SAMPLES_SUCCESS = 'GET_BIOCHAR_LAB_SAMPLES_SUCCESS';
export const GET_BIOCHAR_LAB_SAMPLES_FAIL = 'GET_BIOCHAR_LAB_SAMPLES_FAIL';

export const POST_BIOCHAR_LAB_SAMPLES_SUCCESS = 'POST_BIOCHAR_LAB_SAMPLES_SUCCESS';
export const POST_BIOCHAR_LAB_SAMPLES_FAIL = 'POST_BIOCHAR_LAB_SAMPLES_FAIL';

export const GET_BIOCHAR_LAB_SAMPLES_CONTAMINANTS_SUCCESS = 'GET_BIOCHAR_LAB_SAMPLES_CONTAMINANTS_SUCCESS';
export const GET_BIOCHAR_LAB_SAMPLES_CONTAMINANTS_FAIL = 'GET_BIOCHAR_LAB_SAMPLES_CONTAMINANTS_FAIL';

export const POST_BIOCHAR_LAB_SAMPLES_CONTAMINANTS_SUCCESS = 'POST_BIOCHAR_LAB_SAMPLES_CONTAMINANTS_SUCCESS';
export const POST_BIOCHAR_LAB_SAMPLES_CONTAMINANTS_FAIL = 'POST_BIOCHAR_LAB_SAMPLES_CONTAMINANTS_FAIL';

export const GET_IGNITION_FUEL_SUCCESS = 'GET_IGNITION_FUEL_SUCCESS';
export const GET_IGNITION_FUEL_FAIL = 'GET_IGNITION_FUEL_FAIL';

export const POST_IGNITION_FUEL_SUCCESS = 'POST_IGNITION_FUEL_SUCCESS';
export const POST_IGNITION_FUEL_FAIL = 'POST_IGNITION_FUEL_FAIL';

export const GET_EQUIPMENT_TRANSPORT_SUCCESS = 'GET_EQUIPMENT_TRANSPORT_SUCCESS';
export const GET_EQUIPMENT_TRANSPORT_FAIL = 'GET_EQUIPMENT_TRANSPORT_FAIL';

export const POST_EQUIPMENT_TRANSPORT_SUCCESS = 'POST_EQUIPMENT_TRANSPORT_SUCCESS';
export const POST_EQUIPMENT_TRANSPORT_FAIL = 'POST_EQUIPMENT_TRANSPORT_FAIL';
